/*
 * Example of using grid editing callbacks \ functions
 */

rs.module("development/codedemosgridediting", [],

    function () {

        function initialize(grid, jsSelectors) {

            var acceptImmediately = $.js(jsSelectors.acceptImmediately).prop("checked");

            // Add
            $.js(jsSelectors.addLink).on("click", function () {
                grid.addRow();
            });

            // Accept
            $.js(jsSelectors.acceptLink, { required: false }).on("click", function () {
                grid.acceptChanges();
            });

            // Reject
            $.js(jsSelectors.rejectLink, { required: false }).on("click", function () {
                grid.rejectChanges();
            });

            // List
            $.js(jsSelectors.listLink).on("click", function () {
                grid.getChanges().forEach(change => console.log(change));
            });

            // Callback for when rows change
            grid.rowChanged(function (change) {

                if (acceptImmediately) {
                    change.accept();
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);